module.exports = __webpack_public_path__ + "img/1545459471.c5d8ab0c.jpg";